export default __webpack_public_path__ + "static/media/bed.6c47fa6e.jpg";